import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { BaseFormComponent } from 'src/app/page/tank/components/_base-form/base-form.component';
import { LogService } from 'src/app/services/log.service';
import { OrganizationService} from 'src/app/services/organization.service';
import { LocationService } from '../../services/location.service';
import { IDeliveryEfficiencyForm } from './IDeliveryEfficiencyForm';

@Component({
  selector: 'app-delivery-efficiency-forecasting-form',
  templateUrl: './delivery-efficiency-forecasting-form.component.html',
  styleUrls: ['./delivery-efficiency-forecasting-form.component.css'],
})
export class DeliveryEfficiencyForecastingFormComponent
  extends BaseFormComponent<DeliveryEfficiencyForecastingFormComponent>
  implements OnInit, OnChanges
{
  originalData: IDeliveryEfficiencyForm;
  @Input() dataId: number;
  @Input() dataType: 'location' | 'organization';

  readonly locationDataType: string = 'location';
  readonly organizationDataType: string = 'organization';

  @Output() isDirtySet = new EventEmitter<boolean>();
  get isLocation(): boolean {
    return this.dataType === this.locationDataType;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private orgService: OrganizationService,
    private locSerivce: LocationService,
    private logger: LogService,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) {
    super(formBuilder);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataId) {
      // call the appropriate service base on the data type
      var result: any = null;
      switch (this.dataType) {
        case   this.organizationDataType: {
          result = this.orgService.getDeliveryEfficiency(this.dataId);
          break;
        }
        case this.locationDataType: {
          result = this.locSerivce.getDeliveryEfficiency(this.dataId);
          break;
        }
        default: {
          return;
        }
      }

      if (result != null) {
        result.pipe(takeUntil(this.destroy$))
          .subscribe((x) => {
            this.originalData = x;
            this.formGroup.patchValue(x);
          });
      }
    }
  }

  ngOnInit() {
    this.initForm();
    this.initListeners()
  }


  initListeners() {
    this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.isDirtySet.emit(this.formGroup.dirty);
      },
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onSaveClicked() {
    if (!this.formGroup.valid) {
      return;
    }

    // update the data based on the data type
    // call the appropriate service base on the data type
    var result: any;
    switch (this.dataType) {
      case this.organizationDataType: {
        result = this.orgService.setDeliveryEfficiency(this.dataId, this.formGroup.value)
        break;
      }
      case this.locationDataType: {
        result = this.locSerivce.setDeliveryEfficiency(this.dataId, this.formGroup.value)
        break;
      }
      default: {
        return;
      }
    }

    result.subscribe({
      next: (x) => {
        this.originalData = this.formGroup.value;
        this.formGroup.markAsPristine();
        this.formGroup.markAsUntouched();
      },
      error: (err) => {
        this.logger.error('Error saving delivery efficiency', err);
      },
    });

    this.isDirtySet.emit(false);
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      sunday: [false],
      monday: [false],
      tuesday: [false],
      wednesday: [false],
      thursday: [false],
      friday: [false],
      saturday: [false],
    });
  }

  onResetClicked() {
    this.formGroup.patchValue(this.originalData);
    this.isDirtySet.emit(false);
  }

  selectAllDays() {
    this.formGroup.patchValue({
      sunday: true,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
    });

    this.formGroup.markAsDirty();
    this.isDirtySet.emit(this.formGroup.dirty);
  }

  selectWeekdays() {
    this.formGroup.patchValue({
      sunday: false,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
    });

    this.formGroup.markAsDirty();
    this.isDirtySet.emit(this.formGroup.dirty);
  }

  selectWeekends() {
    this.formGroup.patchValue({
      sunday: true,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: true,
    });

    this.formGroup.markAsDirty();
    this.isDirtySet.emit(this.formGroup.dirty);
  }
}
